import { TBColumn } from "../../interfaces/TableBits.interfaces";

const columns: TBColumn[] = [
  {
    id: "bussinesName",
    label: "Nombre",
    align: "left",
    width: 350,
  },
  // {
  //     id: "Sede",
  //     label: 'Sede',
  //     align: 'left',
  // },
  // {
  //     id: "Cliente",
  //     label: 'Cliente',
  //     align: 'left',
  // },
  {
    id: "dropType",
    label: "Tipo de baja",
    align: "left",
    width: 250,
  },
  {
    id: "comment",
    label: "Razón",
    align: "left",
    width: 250,
  },
  {
    id: "project",
    label: "Proyecto",
    align: "left",
    width: 150,
  },
  {
    id: "FechaIngreso",
    label: "Fecha ingreso",
    align: "left",
    width: 130,
  },
  {
    id: "FechaBaja",
    label: "Fecha baja",
    align: "left",
    width: 130,
  },
];

export default columns;
